
/**
 * Unauthorized request
 */
export type UnauthorizedResponse = void;
